<template>
    <div class="container-fluid">
        <div class="row nav-bg-story">
            <div class="mx-auto statusBar hr-scroll clearfix">
                <div id="stories" class="float-left">
                    <!-- auto-embbed the users stories here -->
                </div>
                <div class="float-left d-none">
                    <ul>
                        <li v-for="(story, index) in stories" :key="index">
                            <img :src="storyHolder">
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { appendImgHostUrl } from '@/store/dry'

export default {
    name: "Story",
    data() {
        return {
            stories: 10,
            storyHolder: require('../../../../../public/img/story/camera-add.png'),
        }
    },
    methods: {
        addBlurToBg() {
            // Created the "story Blured Background"
            var zuckModal = document.querySelector("#zuck-modal");
            zuckModal.insertAdjacentHTML(
                "beforeend",
                `<div id="storyBluredBg" style="background-image: url('');"></div>`
            );

            // Every 10 miliseconds check if bg-image is same as curent active image, else change it to that.
            setInterval(() => {
                var storyBluredBg = document.getElementById("storyBluredBg");
                var currentStoryImgElem = document.querySelector(
                    " div.story-viewer.viewing > .slides > .item.active > img.media"
                );

                if (currentStoryImgElem != null) {
                    var currentStoryImg = currentStoryImgElem.getAttribute("src");
                    var storyBluredBgImg = storyBluredBg.style.backgroundImage
                        .split('url("')[1]
                        .split('")')[0];

                    // If storyBluredBgImg not equal to currentStoryImg, if true change bg-image to currentStoryImg
                    storyBluredBg.style.backgroundImage = `url('${currentStoryImg}')`
                }
            }, 10);
        },
        storiesEngine() {
            let stories = new Zuck("stories", {
                backNative: true,
                autoFullScreen: false,
                skin: "Snapgram",
                avatars: true,
                list: false,
                cubeEffect: true,
                localStorage: true,
                stories: this.theStories
            })
        },
    },
    computed: {
        ...mapGetters(['setStories']),
        theStories() {
            if(this.setStories && this.setStories.length){
                // activate the story display
                this.storyAvailable = true

                // update the this.stories val
                this.stories = this.setStories.length < 10 ? 10 - this.setStories.length : 0
                let readyStories = []
                for(let x=0; x < this.setStories.length; x++){
                    // re-prepare the items-object
                    let buildItemArr = []
                    for(var y=0; y < this.setStories[x].items.length; y++){
                        var itemPhotosObj = {
                            id: this.setStories[x].items[y].id,
                            type: this.setStories[x].items[y].type,
                            length: this.setStories[x].items[y].length,
                            src: appendImgHostUrl(this.setStories[x].items[y].src),
                            preview: this.setStories[x].items[y].preview,
                            link: this.setStories[x].items[y].link,
                            linkText: this.setStories[x].items[y].linkText,
                            seen: this.setStories[x].items[y].seen,
                            time: this.setStories[x].items[y].time
                        }
                        buildItemArr.push(itemPhotosObj)
                    }
                    // prepare the story obj
                    let storyObj = {
                        id: this.setStories[x].id,
                        photo: appendImgHostUrl(this.setStories[x].photo),
                        name: `@${this.setStories[x].name}`,
                        link: this.setStories[x].link,
                        lastUpdated: this.setStories[x].lastUpdated,
                        items: buildItemArr
                    }
                    readyStories.push(storyObj)
                }
                return readyStories
            }
            return false
        }
    },
    mounted() {
        this.storiesEngine()
        this.addBlurToBg()
    }
}
</script>